import moment from 'moment'

import { CommerceSystems } from 'types/Billing'
import { PlanType, Subscription } from 'types/Subscription'

export const isResolveSubscription = (subscription: Subscription): boolean =>
  !!subscription.productFamilyKey?.match(/\bresolve\b/gi)

export const isTrial = (subscription: Subscription): boolean => subscription.planType === PlanType.Trial

export const isFree = (subscription: Subscription): boolean => subscription.planType === PlanType.Freemium

export const isAddon = (subscription: Subscription): boolean => !!subscription.addOn

export const isFreeResolveSubscription = (subscription: Subscription): boolean =>
  isResolveSubscription(subscription) && isFree(subscription)

export const isTrialResolveSubscription = (subscription: Subscription): boolean =>
  isResolveSubscription(subscription) && isTrial(subscription)

export const isFreeOrTrialNonAddonResolveSubscription = (subscription: Subscription): boolean =>
  (isFreeResolveSubscription(subscription) || isTrialResolveSubscription(subscription)) && !isAddon(subscription)

export const getSubscriptionRemainingDays = (subscription: Subscription): number =>
  moment(subscription.endDate).diff(moment(), 'days') + 1

export const getCaseInsensitiveCommerceSystem = (commerceSystems: CommerceSystems | undefined, key: string) =>
  commerceSystems ? Object.keys(commerceSystems).some((k) => k?.toUpperCase() === key.toUpperCase()) : false
